import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';

@customElement('visual-solar-light-temperature')
export class VisualSolarLocation extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 100%;
			height: 100%;
			overflow: hidden;
		}
		.container {
			width: 60%;
			margin: auto;
			display: flex;
		}
		@media (max-width: 768px) {
			.container {
				margin-left: 0;
			}
		}
		.svg {
			width: 100%;
			margin: auto;
			display: block;
			padding-bottom: 20%;
		}

	`;

	render() {
		return html`
			<div class="container">
				<svg-temperature class="svg"></svg-temperature>
			</div>
        `;
	}
}
